































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { accountLevel, displayAccountLevel } from '../helper/account-level'
import { accountPriority, displayAccountPriority } from '../helper/account-priority'

@Component({})
export default class CasePrioritySwitcher extends Vue {
  @Prop({ type: Number }) readonly value!: number
  @Prop({ type: Number }) readonly caseId!: number
  @Prop({ type: Array }) readonly options!: string[]
  @Prop({ type: String }) readonly type!: string

  accountLevel = accountLevel
  displayAccountLevel = displayAccountLevel
  accountPriority = accountPriority
  displayAccountPriority = displayAccountPriority

  showList = false

  index = -1
  showTag () {
    if (this.type === 'level') {
      return (displayAccountLevel(this.value))
    } else {
      return (displayAccountPriority(this.value))
    }
  }

  async onSelect (index: number) {
    this.showList = false
    this.index = index - 1
    this.onSelectItem()
  }

  @Emit('onSelect')
  onSelectItem () {
    // do nothing
    this.showList = false
    return this.index
  }
}
